// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2ER8q","signatureBlock":"Footer_signatureBlock__TGK_r","signature":"Footer_signature__23h3R"};